import React from "react"
import { Col, Row} from 'antd'
import './leftVideo.scss'

const LeftVideo = () => {
	return (
		<div className="leftVideo">
			<iframe width="558" height="100%" src="https://www.youtube.com/embed/7RomhheiE50?si=YE5k7Lw2rx23O4jJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
		</div>
	)
}

export default LeftVideo
